const crmTranslation = {
  mode: 'en',
  menu: 'CRM',

  crm: 'CRM Records',
  cs: 'CS',
  channelTalkRequests: 'ChannelTalk Requests',
  detail: 'Detailed Records',
  crmTitle: 'CRM History',
  crmTypeTitle: 'CRM Type Management',
  sendTaChannel: 'Notify Technical Support Channel',
  addCrm: 'Add Record',
  editCrm: 'Edit Record',
  deleteCrm: 'Delete Record',
  slackLink: 'Slack Link',
  manageType: 'Manage Type',
  addType: 'Add Type',
  searchType: 'Search Type Name',
  selectType: 'Select Type',
  selectStatus: 'Select Status',
  insertDescription: 'Insert Description',
  sendSlack: 'Send Message to Slack',

  seq: 'Number',
  hospital: 'Account',
  hospitalName: 'Account Name',
  unassignedHospital: 'Unassigned Account',
  hospitalRoom: 'Location',
  type: 'Type',
  typeName: 'Type Name',
  crmStatus: 'Status',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  actor: 'PIC',
  description: 'Description',
  processing: 'In Progress',
  keep: 'Hold',
  complete: 'Closed',
  archive: 'Archive',
  actions: 'Actions',
  approve: 'Approve',
  manualComplete: 'Complete',
  rollback: 'Rollback',
  bulkApprove: 'Bulk Approve',
  reject: 'Reject',
  detailReview: 'Review',
  detailView: 'View Detail',
  saveReview: 'Save Review',
  editField: 'Edit Value',
  viewOriginalData: 'View Original Data',
  conversationSectionTitle: 'Conversation',
  requestDetailsSectionTitle: 'Request Details',
  processingDetailsSectionTitle: 'Processing History',
  recordingDetailsSectionTitle: 'Recording Data',
  recordingSelectionTitle: 'Select Recording',
  hospitalSelectionTitle: 'Select Hospital',
  roomSelectionTitle: 'Select Room',
  recordingSearchPlaceholder: 'Search by barcode, recording seq, or room',
  selectHospitalFirst: 'Select a hospital first.',
  noHospitalRooms: 'No rooms available',
  conversationInputLabel: 'Message to hospital',
  conversationInputPlaceholder: 'Write what you need to confirm with the hospital.',
  sendConversationMessage: 'Send Message',
  requestMessage: 'Request Message',
  rollbackReason: 'Rollback Reason',
  barcodeLookup: 'Verify Barcode',
  barcodeLookupDescription: 'Review the recordings and CS user information for this barcode again.',
  barcodeLookupUserInfo: 'CS User Info',
  barcodeLookupRecordings: 'Recordings',
  userInfoName: 'Name',
  userInfoSeq: 'User Seq',
  userInfoPhone: 'Phone Number',
  userInfoBabies: 'Baby Info',
  videoLengthLabel: 'Video Length',
  editDurationPlaceholder: 'e.g. up to 3m 27s',
  yes: 'Yes',
  no: 'No',
  channelTalkDetailTitle: 'ChannelTalk Request Detail',
  channelTalkReviewTitle: 'Request Review',
  channelTalkRejectTitle: 'Reject ChannelTalk Request',
  channelTalkApproveDecisionTitle: 'Confirm Approval',
  channelTalkCompleteDecisionTitle: 'Confirm Manual Completion',
  channelTalkBulkApproveDecisionTitle: 'Confirm Bulk Approval',
  channelTalkRejectReason: 'Reject Reason',
  channelTalkRejectResponseMessage: 'ChannelTalk Response Message',
  channelTalkMessageDecisionLabel: 'Send ChannelTalk message',
  channelTalkApproveDecisionDescription:
    'Choose whether to send the completion message below together with approval.',
  channelTalkCompleteDecisionDescription:
    'Choose whether to send a ChannelTalk message together with manual completion.',
  channelTalkBulkApproveDecisionDescription:
    'You are about to bulk approve {{count}} requests. Choose whether to send ChannelTalk messages.',
  channelTalkResponseMessagePreviewLabel: 'Message Preview',
  channelTalkSendMessageQuestion: 'Send this message?',
  sendResponseMessage: 'Send Message',
  skipResponseMessage: 'Do Not Send',

  channelTalkStatus: {
    pending: 'Pending',
    executing: 'Executing',
    executed: 'Executed',
    rejected: 'Rejected',
    failed: 'Failed',
  },

  channelTalkWorkflow: {
    transfer: 'Transfer',
    delete: 'Delete',
    edit: 'Edit',
  },

  channelTalkExecutionMode: {
    auto: 'Auto',
    review: 'Review',
  },

  channelTalkProcess: {
    requestReceived: 'Request Received',
    reviewInProgress: 'Review',
    additionalConversation: 'Additional Conversation',
    additionalWaiting: 'Waiting for More Info',
    waitingReply: 'Waiting for Hospital Reply',
    replyReceived: 'Hospital Reply Received',
    finalize: 'Finalize',
    executed: 'Approved',
    rejected: 'Rejected',
    failed: 'Failed',
  },

  channelTalkProcessSummary: {
    idle: 'You can ask for more details from the hospital here and keep reviewing the responses.',
    waitingReply: 'A follow-up question was sent and the hospital reply is pending.',
    replyReceived: 'A hospital reply has arrived. Review it and finalize the request.',
    executed: 'Final processing is complete.',
    rejected: 'The request has been rejected.',
    failed: 'The request is in a failed state.',
  },

  channelTalkFilters: {
    status: 'Status',
    workflowType: 'Workflow',
    executionMode: 'Execution Mode',
    search: 'Search hospital, user, barcode',
  },

  channelTalkColumns: {
    status: 'Status',
    workflowType: 'Workflow',
    executionMode: 'Execution Mode',
    hospitalName: 'Hospital',
    hospitalRoomName: 'Room',
    userName: 'User',
    barcode: 'Barcode',
    sourceBarcode: 'Source Barcode',
    targetBarcode: 'Target Barcode',
    recordedAt: 'Recorded At',
    summary: 'Review / Result',
    decisionBy: 'Handler',
    createdAt: 'Created At',
    requestedAt: 'Requested At',
    recordingSeq: 'Recording Seq',
    reviewReason: 'Review Reason',
    resultMessage: 'Result Message',
    editDuration: 'Edit Duration',
    decisionAt: 'Decision At',
    executedAt: 'Executed At',
    messageSentFlag: 'Response Sent',
    responseMessageSentAt: 'Response Sent At',
    responseMessageText: 'Response Message',
    slackInfo: 'Slack Message Info',
    userChatId: 'User Chat ID',
    submitData: 'Original Submit Data',
    originalRequestData: 'Request Data',
    processedAt: 'Processed At',
  },

  channelTalkSnapshot: {
    statusCompareTitle: 'State Comparison',
    changeListTitle: 'Review Changes',
    fullStateToggle: 'Expand Full State',
    requestValue: 'Requested',
    currentValue: 'Current',
    savedValue: 'Modified',
    noChanges: 'There are no saved changes yet.',
    capturedAt: 'Captured At',
    requestStateTitle: 'Requested State',
    currentStateTitle: 'Current State',
    savedReviewTitle: 'Saved Review Values',
    sourceState: 'Source Recording State',
    targetState: 'Target Recording State',
    targetValueState: 'Target Barcode / Recording',
    locationState: 'Hospital / Room',
    decisionState: 'Decision',
    currentExecutable: 'Executable Now',
    manualCompletionDetected: 'External Manual Completion',
    manualCompletionDetectedValue: 'Manual handling detected',
    manualCompletionChip: 'Manual handling detected',
    rollbackChip: 'Rollback available',
    currentReviewReason: 'Current Review Reason',
  },

  channelTalkWorkBadge: {
    delete: 'Deleted',
    edit: 'Edited',
  },

  channelTalkMessages: {
    approveSuccess: 'Request approved.',
    approveFailed: 'Failed to approve request.',
    completeSuccess: 'Request marked complete.',
    completeFailed: 'Failed to mark request complete.',
    rejectSuccess: 'Request rejected.',
    rejectFailed: 'Failed to reject request.',
    reviewRequired:
      'Approval is currently unavailable. Please review the detailed information first.',
    reviewSaveSuccess: 'Review changes saved.',
    reviewSaveFailed: 'Failed to save review changes.',
    rollbackSuccess: 'Rolled back the work and returned the request to pending review.',
    rollbackFailed: 'Failed to roll back the work.',
    rollbackUnavailable: 'Rollback is unavailable for the current state.',
    rollbackDescription:
      'This will revert the recording state when supported and move the request back to pending review.',
    rollbackReasonRequired: 'Please enter a rollback reason.',
    rollbackReasonPlaceholder: 'e.g. manual handling was incorrect and needs re-review',
    barcodeLookupFailed: 'Failed to load barcode verification data.',
    noMatchedRecording: 'No recording matches the request.',
    movedToTarget: 'Moved to target barcode state',
    noConversationAvailable:
      'This request does not have a ChannelTalk chat ID, so conversation history is unavailable.',
    noConversationHistory: 'There is no conversation history to display.',
    sendConversationSuccess: 'Message sent.',
    sendConversationFailed: 'Failed to send message.',
    conversationMessageRequired: 'Please enter a message to send.',
    conversationSendUnavailable: 'Message sending is disabled for this request.',
    noUserInfo: 'No CS user information found.',
    noRecordingCandidates: 'No recording matches the request.',
    editDurationRecordingRequired: 'Select a recording before editing the interval.',
    editDurationRecordingLoadFailed: 'Failed to load the recording for interval editing.',
    editDurationInvalidRange: 'Please review the edit interval before saving.',
    defaultRejectResponse:
      'Hello.\n\nWe reviewed your request, but we need additional confirmation before we can process it.\nPlease check the details again and contact us once more.\n\nThank you.',
    bulkApproveSuccess: '{{count}} requests approved.',
    bulkApproveFailed: 'Failed to bulk approve requests.',
    bulkApprovePartial: 'Success {{successCount}} / Failed {{failureCount}}',
    closedConversationCompleted: 'The conversation was closed, so the request was marked complete.',
    closedConversationReviewAction: 'Review Request',
    currentStatusRefreshFailed: 'Failed to refresh the current state.',
  },

  workflowRequirement: {
    requestValue: 'Request',
    savedValue: 'Current',
    supportInfo: 'Detail Info',
    videoLabel: 'Video',
    videoDescription:
      'Find the recording from the original request data and select the recording number.',
    videoFind: 'Find Video',
    videoChange: 'Change Video',
    sourceBarcodeChange: 'Change Source Barcode',
    targetBarcodeLabel: 'Target Barcode',
    targetBarcodeDescription: 'Verify the target barcode and save it before running transfer.',
    targetBarcodeVerify: 'Verify Barcode',
    targetBarcodeChange: 'Change Target Barcode',
    editRangeLabel: 'Edit Range',
    editRangeDescription: 'Once the video is selected, set the edit range from the request text.',
    editRangeSet: 'Set Edit Range',
    editRangeChange: 'Change Edit Range',
    editPointChange: 'Change Edit Range',
    currentBarcodeLabel: 'Current barcode',
    currentVideoLengthLabel: 'Current video length',
    deleteFlagLabel: 'Delete state',
    deleteFlagDeleted: 'Deleted',
    deleteFlagActive: 'Active',
    configuredEditRangeLabel: 'Configured edit range',
    summary: {
      transfer: 'You can run transfer once the video and target barcode are resolved.',
      edit: 'You can run edit once the video and edit range are resolved.',
      delete: 'You can run delete once the video is found.',
    },
    reviewRequiredTitle: 'There are still items that require review.',
    status: {
      unresolved: 'Unresolved',
      selected: 'Selected',
      needsVerification: 'Needs verification',
      valid: 'Valid',
      needsSetup: 'Needs setup',
      configured: 'Configured',
    },
  },

  crmDownload: 'Download CRM History',
  crmExcel: 'MDA-CRM_History.xlsx',

  deleteMessage: 'Delete CRM history number?',
  deleteTypeMessage: 'Delete type?',
};

export default crmTranslation;
